import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { CartContext } from '@/contexts/CartContext';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { TmProvince } from '@/tscapi/model/account';
import { TmCartProvincialTaxRequest } from '@/tscapi/model/request/cart-request';

interface OrderSummaryProps {
    checkoutStep: string;
}

export const OrderSummary = ({ checkoutStep }: OrderSummaryProps) => {
    const { cartData, updateTaxes, setUpdateTaxes, orderModificationMode, modifiedOrderSummary } =
        useContext(CartContext);

    const [provinceCode, setProvinceCode] = useState('ON');
    const { t } = useTranslation();

    useEffect(() => {
        if (updateTaxes) {
            const provinceCode = updateTaxes;
            setUpdateTaxes('');
            if (checkoutStep == 'create-account') {
                const updateCartTaxes = async () => {
                    try {
                        const provinceRequest = new TmCartProvincialTaxRequest();
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        //@ts-ignore
                        provinceRequest.Province = provinceCode;
                        setProvinceCode(provinceCode);
                    } catch (error) {
                        console.log('error:' + error);
                    }
                };
                updateCartTaxes();
            }
        }
    }, [checkoutStep, setUpdateTaxes, updateTaxes]);

    return (
        <>
            {orderModificationMode ? (
                <div className="OrderSummaryWrap">
                    <h2>{t('Modified Order Summary')}</h2>

                    {cartData && modifiedOrderSummary && (
                        <div className="summary">
                            <div className="summary__row">
                                <span className="summary__label">{t('Subtotal')}:</span>
                                <span className="summary__value">{modifiedOrderSummary.MerchandiseSubTotal}</span>
                            </div>

                            <div className="summary__row">
                                <span className="summary__label">{t('Shipping')}:</span>
                                <span className="summary__value">
                                    {/*<del>*/}
                                    {/*    {modifiedOrderSummary.DefaultShippingHandling == null ||*/}
                                    {/*    modifiedOrderSummary.DefaultShippingHandling ==*/}
                                    {/*        modifiedOrderSummary.ShippingHandling*/}
                                    {/*        ? null*/}
                                    {/*        : modifiedOrderSummary.DefaultShippingHandling}*/}
                                    {/*</del>*/}
                                    {modifiedOrderSummary.ShippingHandling == '$0.00'
                                        ? t('Free')
                                        : modifiedOrderSummary.ShippingHandling}
                                </span>
                            </div>

                            <div className="summary__row">
                                <span className="summary__label">
                                    {t('Est Taxes')}:{' '}
                                    {modifiedOrderSummary ? modifiedOrderSummary.ShipmentProvince : ''}
                                </span>
                                <span className="summary__value">{modifiedOrderSummary.TaxTotal}</span>
                            </div>

                            {modifiedOrderSummary.DiscountAmount > 0 && (
                                <div className="summary__row">
                                    <span className="summary__value leftAlign">
                                        <b className="uppercase">{t('Applied Discounts')}</b>
                                    </span>
                                </div>
                            )}

                            {modifiedOrderSummary.DiscountAmount > 0 && (
                                <div className="summary__row">
                                    <span className="summary__label">{t('Discount')}</span>
                                    <span className="summary__value">-{modifiedOrderSummary.Discount}</span>
                                </div>
                            )}

                            {modifiedOrderSummary.GiftCard ? (
                                <div className="summary__row">
                                    <span className="summary__label uppercase">{t('Gift Card Redeemed')}</span>
                                    <span className="summary__value">-{modifiedOrderSummary.GiftCard}</span>
                                </div>
                            ) : null}

                            {modifiedOrderSummary.AppliedCreditAmount > 0 ? (
                                <div className="summary__row uppercase">
                                    <span className="summary__label">{t('Account Credit')}</span>
                                    <span className="summary__value">-{modifiedOrderSummary.AppliedCredit}</span>
                                </div>
                            ) : null}

                            <div className="summary__row">
                                <span className="summary__label bold uppercase">{t('NEW TOTAL PRICE')}:</span>
                                <span className="summary__value bold uppercase">{modifiedOrderSummary.GrandTotal}</span>
                            </div>

                            <div className="summary__row">
                                <span className="summary__label">{t('Original Order Total')}:</span>
                                <span className="summary__value">{modifiedOrderSummary.PreviousOrderTotal}</span>
                            </div>
                            <div className="summary__row">
                                <span className="summary__label">{t('Change to Order Total')}:</span>
                                <span className="summary__value">{modifiedOrderSummary.OrderTotalDifference}</span>
                            </div>

                            {modifiedOrderSummary.EasyPay && (
                                <div className="easypay__container">
                                    <div className="summary__row">
                                        <h3 className="easypay__title--border">
                                            {t('Monthly payments with easy pay')}
                                        </h3>
                                    </div>

                                    <div className="summary__row">
                                        <span className="summary__label--wide">{t('Number of Installments')}:</span>
                                        <span className="summary__value">
                                            {modifiedOrderSummary.EasyPay.NoOfInstallments}
                                        </span>
                                    </div>

                                    <div className="summary__row">
                                        <span className="summary__label--wide">{t('Your Total Payment Today')}:</span>
                                        <span className="summary__value">
                                            {modifiedOrderSummary.EasyPay.TotalPaymentToday}
                                        </span>
                                    </div>
                                    <div className="summary__row">
                                        <span className="summary__label--wide">
                                            {t('Payment Amount Left After Today')}:
                                        </span>
                                        <span className="summary__value">
                                            {modifiedOrderSummary.EasyPay.BalanceRemainingAfterToday}
                                        </span>
                                    </div>
                                    <div className="summary__row">
                                        <span className="summary__label--wide">
                                            {modifiedOrderSummary.EasyPay.NoOfInstallments - 1}{' '}
                                            {t('Future Monthly Payments')}
                                        </span>
                                        <span className="summary__value">
                                            {modifiedOrderSummary.EasyPay.FutureMonthlyPayment}
                                        </span>
                                    </div>
                                </div>
                            )}
                        </div>
                    )}
                </div>
            ) : (
                <div className="OrderSummaryWrap">
                    <h2>{t('Order Summary')}</h2>

                    {cartData && cartData.OrderSummary && (
                        <div className="summary">
                            <div className="summary__row">
                                <span className="summary__label">{t('Subtotal')}:</span>
                                <span className="summary__value">{cartData.OrderSummary.MerchandiseSubTotal}</span>
                            </div>
                            {cartData.PromoCode &&
                                cartData.PromoCode !== 'FREESHIP' &&
                                cartData.OrderSummary.Discount && (
                                    <div className="summary__row">
                                        <span className="summary__label bold">
                                            {cartData.PromoCode}

                                            {cartData.OrderSummary.PromotionValue &&
                                                cartData.OrderSummary.Discount !== '$0.00' && (
                                                    <span className="summary__label--discount">
                                                        {' '}
                                                        – {cartData.OrderSummary.PromotionValue}
                                                    </span>
                                                )}
                                        </span>

                                        <span className="summary__value bold">
                                            {cartData.OrderSummary.Discount !== '$0.00' && <>–</>}
                                            {cartData.OrderSummary.Discount}
                                        </span>
                                    </div>
                                )}
                            {!cartData.PromoCode && cartData.OrderSummary.DiscountAmount > 0 && (
                                <div className="summary__row">
                                    <span className="summary__label bold uppercase">
                                        {t('Discount')}
                                        {cartData.OrderSummary.PromotionValue &&
                                            cartData.OrderSummary.Discount !== '$0.00' && (
                                                <span className="summary__label--discount">
                                                    {' '}
                                                    – {cartData.OrderSummary.PromotionValue}
                                                </span>
                                            )}
                                    </span>
                                    <span className="summary__value bold">
                                        {cartData.OrderSummary.DiscountAmount > 0 && <>–</>}
                                        {cartData.OrderSummary.Discount}
                                    </span>
                                </div>
                            )}
                            <div className="summary__row">
                                <span className="summary__label">{t('Shipping')}:</span>
                                <span className="summary__value">
                                    {cartData.OrderSummary.ShippingHandling == '$0.00'
                                        ? t('Free')
                                        : cartData.OrderSummary.ShippingHandling}
                                </span>
                            </div>

                            {cartData.PromoCode &&
                                cartData.PromoCode === 'FREESHIP' &&
                                cartData?.OrderSummary?.Discount && (
                                    <div className="summary__row">
                                        <span className="summary__label bold uppercase">{cartData.PromoCode}</span>
                                        <span className="summary__value bold">
                                            {cartData.OrderSummary.Discount !== '$0.00' && <>–</>}
                                            {cartData.OrderSummary.Discount}
                                        </span>
                                    </div>
                                )}

                            <div className="summary__row">
                                <span className="summary__label">
                                    {t('Est Taxes')}:{' '}
                                    {checkoutStep === 'create-account'
                                        ? 'ON'
                                        : cartData.ShippingAddress
                                          ? cartData.ShippingAddress.State
                                          : provinceCode}
                                </span>
                                <span className="summary__value">{cartData.OrderSummary.TaxTotal}</span>
                            </div>

                            {cartData.OrderSummary.GiftCard != '' ? (
                                <div className="summary__row">
                                    <span className="summary__label">{t('Gift Card Redeemed')}</span>
                                    <span className="summary__value">-{cartData.OrderSummary.GiftCard}</span>
                                </div>
                            ) : null}

                            {cartData.OrderSummary.AppliedCreditAmount > 0 ? (
                                <div className="summary__row--account-credit">
                                    <span className="summary__label">{t('Account Credit')}</span>
                                    <span className="summary__value">-{cartData.OrderSummary.AppliedCredit}</span>
                                </div>
                            ) : null}

                            <div className="summary__row">
                                <span className="summary__label bold uppercase">{t('TOTAL PRICE')}:</span>
                                <span className="summary__value bold uppercase">
                                    {cartData.OrderSummary.GrandTotal}
                                </span>
                            </div>

                            {cartData.OrderSummary.EasyPay && (
                                <div className="easypay__container">
                                    <div className="summary__row">
                                        <h3 className="easypay__title--border">
                                            {t('Monthly payments with easy pay')}
                                        </h3>
                                    </div>

                                    <div className="summary__row">
                                        <span className="summary__label--wide">{t('Number of Installments')}:</span>
                                        <span className="summary__value">
                                            {cartData.OrderSummary.EasyPay.NoOfInstallments}
                                        </span>
                                    </div>

                                    <div className="summary__row">
                                        <span className="summary__label--wide">{t('Your Total Payment Today')}:</span>
                                        <span className="summary__value">
                                            {cartData.OrderSummary.EasyPay.TotalPaymentToday}
                                        </span>
                                    </div>
                                    <div className="summary__row">
                                        <span className="summary__label--wide">
                                            {t('Payment Amount Left After Today')}:
                                        </span>
                                        <span className="summary__value">
                                            {cartData.OrderSummary.EasyPay.BalanceRemainingAfterToday}
                                        </span>
                                    </div>
                                    <div className="summary__row">
                                        <span className="summary__label--wide">
                                            {cartData.OrderSummary.EasyPay.NoOfInstallments - 1}{' '}
                                            {t('Future Monthly Payments')}:
                                        </span>
                                        <span className="summary__value">
                                            {cartData.OrderSummary.EasyPay.FutureMonthlyPayment}
                                        </span>
                                    </div>
                                </div>
                            )}
                        </div>
                    )}
                </div>
            )}
        </>
    );
};
